import { FC } from 'react';

import { Box, Stack, Typography } from '@mui/material';
import { red } from '@mui/material/colors';
import { Globe } from 'phosphor-react';

import { useSession } from '~components/hooks/useSession';
import { FullWidthDivider } from '~components/shared/divider';
import { IconArbitrumLogo } from '~components/shared/icons';
import { primaryColors } from '~components/theme/styles/colors';
import { NetworkIds } from '~config/rpcConfig';

import { AccountPanel } from './accountPanel';
import { AccountPanelOption } from './accountPanelOption';

export const AccountDialNetworks: FC<{ forceOpen?: boolean }> = ({ forceOpen }) => {
  const {
    network: { isChainValid },
    switchNet,
  } = useSession();
  return (
    <AccountPanel
      titleContent="Networks"
      titleIcon={<Globe size={22} color={isChainValid ? primaryColors[400] : red[800]} />}
      forceOpen={forceOpen}
    >
      <AccountPanelOption
        sx={{ display: 'flex', justifyContent: 'start', gap: '16px', alignItems: 'center' }}
        onClick={() => switchNet(NetworkIds.ARBITRUM_ONE)}
      >
        <IconArbitrumLogo width={24} height={24} />
        <Typography variant="label3" sx={{ color: primaryColors[400] }}>
          ARBITRUM ONE
        </Typography>
      </AccountPanelOption>
      {!isChainValid && (
        <Box>
          <FullWidthDivider sx={{ py: 1 }} offsetPadding={32} />
          <Stack pb={4} pt={3} spacing={4}>
            <Typography variant={'base'} color={primaryColors[100]}>
              You are connected to an unsupported network!
            </Typography>
            <Typography variant={'body2'} color={primaryColors[700]}>
              Please switch your wallet network to a supported network, in order to use the app.{' '}
            </Typography>
          </Stack>
        </Box>
      )}
    </AccountPanel>
  );
};
